import React, { FC, memo, useMemo } from 'react';
import { BreadcrumbItem } from '@cmhc-schl/hearth-ui';
import i18n from 'i18next';
import BreadcrumbV5Adapter from './BreadcrumbV5Adapter';
import styles from './styles.module.scss';
import { BreadcrumbItemFields, HbtBreadcurmbComponentProps } from './types';

const replacePlaceholders = (template: string, ids: Record<string, string> = {}): string => {
  return template.replace(/\${(.*?)}/g, (_, key) => ids[key] || '');
};

const HbtBreadcrumbComponent: FC<HbtBreadcurmbComponentProps> = ({
  ids,
  fields,
  skippedHrefs = []
}) => {
  const breadcrumbItems: BreadcrumbItem[] = useMemo(() => {
    return fields.items
      .map(({ fields }: BreadcrumbItemFields) => {
        const rawHref = fields.breadcrumbNavItem?.value?.href || '';
        const rawLabel = fields.label?.value || '';

        const hrefWithIds = replacePlaceholders(rawHref, ids);
        const labelWithIds = replacePlaceholders(rawLabel, ids);

        if (skippedHrefs.includes(hrefWithIds)) {
          return null;
        }

        const fullHref = `/${i18n.language}${hrefWithIds}`;

        const isCurrentPage =
          typeof window !== 'undefined' && window.location.pathname === fullHref;

        return {
          label: labelWithIds,
          href: fullHref,
          isCurrentPage
        };
      })
      .filter((item) => item !== null) as BreadcrumbItem[];
  }, [fields, ids, skippedHrefs]);

  return (
    <div className={styles.breadcrumbContainer}>
      <BreadcrumbV5Adapter items={breadcrumbItems} condensed={fields.condensed?.value === 'true'} />
    </div>
  );
};

export default memo(HbtBreadcrumbComponent);
